import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { RUN_TYPES } from '~/features/content/utils/content-jobs';

// The Runs tab it was opened from, carried to the new URL.
const searchSchema = z.object({ from: z.enum(RUN_TYPES).optional().catch(undefined) });

/** `/content/jobs/how-it-works` (old name) — redirects to "How runs work" at `/content/runs/how-it-works`. */
export const Route = createFileRoute('/_authenticated/_tenant/content/jobs_/how-it-works')({
  validateSearch: searchSchema,
  beforeLoad: ({ search }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router requires throwing a redirect
    throw redirect({ to: '/content/runs/how-it-works', search });
  },
});
